const GlobalAbortController = new AbortController();

export { GlobalAbortController };
